module.exports = __webpack_public_path__ + "img/car_clond.116255d0.png";